// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBoundary_container__zZf4v","errorBoundary":"ErrorBoundary_errorBoundary__Q_eMf","heading":"ErrorBoundary_heading__HPqpY","desc":"ErrorBoundary_desc__ai9Pl"};